export default "__VITE_ASSET__BMIOtiXL__"